import axiosPublicClient from "../../../../../../axiosPublicClient"

export default async (data) => {
    const result = await axiosPublicClient.post(`/request-paper-form`, data)

    return result.data
}
